import { Injectable } from '@angular/core';
import { PKCEConfiguration } from './p-k-c-e-configuration';
import { ConfigurationModule } from '../../configuration.module';

@Injectable({
  providedIn: ConfigurationModule
})
export class PKCEConfigurationService {

  configuration: PKCEConfiguration;

  constructor() { }

  loadConfiguration(configuration) {
    this.configuration = {
    enabled:true,
    code_challenge_method:"S256"

    }
  }
}
